import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from "../component/Auth/Header";
import Login from "../component/Auth/Login";

export default function LoginPage() {
  const handleLoginSuccess = (role) => {
    toast.success(`Logged in as ${role} successfully!`);
  };

  return (
    <div className="w-full space-y-0 relative top-20 mb-24 flex justify-between m-auto ">
       <ToastContainer />
      <div className="m-auto bg-[#D4C1A7] p-10 rounded-[20px]  ">
        <Header
          heading="Login to your account"
          paragraph="Don't have an account yet? "
          linkName="Signup"
          linkUrl="/signup"
        />
        <Login onLoginSuccess={handleLoginSuccess} />
      </div>
     
     
    </div>
  );
}
